import React from 'react'
import NavigationBar from "../../Modules/NavigationBar";

const PageHeader = () => {
    return (
        <div className={"PageHeader"}>
            <NavigationBar />
        </div>
    )

}

export default PageHeader;